<ng-template [ngIf]="display_mode ==='row'"
             [ngIfThen]="rowCardRef"
             [ngIfElse]="columnCardRef">
</ng-template>

<ng-template #rowCardRef>
  <ng-template [ngIf]="deviceService.isMobile()"
               [ngIfThen]="mobileRowCard"
               [ngIfElse]="desktopRowCardRef">
  </ng-template>
</ng-template>

<ng-template #columnCardRef>
  <div class="card-1">
    <div class="card-cover" [routerLink]="classroomUrl"></div>
    <div class="tutor-item" *ngIf="classroom">
      <div class="cover">
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>
      <div class="full-name">{{classroom.title}}</div>
    </div>
  </div>
</ng-template>

<ng-template #desktopRowCardRef>
  <div class="classroom-mini">
    <div class="card-cover" [routerLink]="classroomUrl"></div>

    <div class="header">
      <div class="cover-wrap">
        <ng-container *ngTemplateOutlet="typeTemplate"></ng-container>
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>
      <div class="info-block">
        <h4 class="title">{{ classroom?.title }}</h4>
        <ng-container *ngTemplateOutlet="stats"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="actions"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </div>
</ng-template>

<ng-template #mobileRowCard>
  <div class="classroom-mini-mobile">
    <div class="card-cover" [routerLink]="classroomUrl"></div>
    <div class="header">
      <div class="cover-wrap">
        <ng-container *ngTemplateOutlet="typeTemplate"></ng-container>
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>
      <div class="info-block">
        <h5 class="title">{{ classroom?.title }}</h5>
      </div>
      <ng-container *ngTemplateOutlet="actions"></ng-container>
    </div>
    <div class="row">
      <ng-container *ngTemplateOutlet="stats"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </div>
</ng-template>

<ng-template #tutor>
  <div class="tutor">
    <div class="label">{{ 'classrooms.classroom.tutor' | customLocale }}</div>
    <app-author-info [withoutFollow]="true" [user]="user"></app-author-info>
  </div>
</ng-template>

<ng-template #typeTemplate>
  <div class="type" *ngIf="isPrivate">{{ 'classrooms.form.access.private' | customLocale }}</div>
</ng-template>

<ng-template #participants>
  <div class="tutor">
    <div class="label">{{ 'classrooms.classroom.participants' | customLocale }}</div>
    <div class="avatars" [class.only-one]="filteredParticipants.length===1" *ngIf="filteredParticipants.length; else noParticipants">
      <ng-container *ngIf="filteredParticipants.length===1">
        <app-author-info [withoutFollow]="true" [user]="(loadParticipant$(filteredParticipants[0].user_id) | async)"></app-author-info>
      </ng-container>

      <ng-container *ngIf="filteredParticipants.length>1">
        <div *ngFor="let participant of filteredParticipants; let i = index; trackBy: participantsTrackByFn"
             [style.transform]="'translateX(' + -8 * i + 'px)'"
             class="avatar-wrap-participant">
          <on-ui-cover [cover]="avatarParticipant(loadParticipant$(participant.user_id) | async)"></on-ui-cover>
        </div>
      </ng-container>
    </div>
    <ng-template #noParticipants>
      <div class="no-count">0</div>
    </ng-template>
    <div class="count" [style.transform]="'translateX(' + -6 * filteredParticipants.length + 'px)'" *ngIf="moreParticipantsCount > 0">+{{moreParticipantsCount}}</div>
  </div>
</ng-template>

<ng-template #stats>
  <div class="stats">
    <span class="stat-item">{{ classroomTypeLabel() | customLocale }}</span>
    <span class="delimiter"></span>
    <span class="stat-item">{{ 'classrooms.classroom.classes' | customLocale }} {{ meetingsCount }}</span>
    <span class="delimiter"></span>
    <span class="stat-item">{{ 'classrooms.classroom.students' | customLocale }} {{ participantsCount }}</span>
  </div>
  <div class="details" *ngIf="classroom?.last_meeting?.id">
    <p class="description">
      {{ 'classrooms.classroom.last-class' | customLocale }} {{meetingTitle(classroom?.last_meeting)}}
    </p>
    <span class="delimiter" *ngIf="!deviceService.isMobile()"></span>
    <span class="date">{{ 'classrooms.classroom.date' | customLocale }} {{ classroom?.last_meeting?.begin_at | dfnsFormat:'d MMM y' }}</span>
  </div>
  <div class="details" *ngIf="classroom?.next_meeting?.id">
    <p class="description">{{ 'classrooms.classroom.next-class' | customLocale }} {{meetingTitle(classroom?.next_meeting)}}
    </p>
    <span class="delimiter" *ngIf="!deviceService.isMobile()"></span>
    <span class="date">{{ 'classrooms.classroom.date' | customLocale }} {{ classroom?.next_meeting?.begin_at | dfnsFormat:'d MMM y' }}</span>
  </div>
</ng-template>

<ng-template #actions>
  <div class="actions">
    <app-icon *ngIf="isPinAvailable() && false"
              icon="pin"
              file="action"
              width="32"
              height="32"
              (click)="togglePined()"
              class="pin-icon"
              [class.active]="isPined">
    </app-icon>
    <on-ui-card-menu>
      <div class="menu-item" *ngIf="contract?.purl"><a [href]="contract?.purl">[⚠️] Panel [contract]</a></div>
      <ng-container *ngFor="let option of options; trackBy: trackByFn">
        <div class="menu-item" *ngIf="isEnabledMenuOption(option)"
             [class.danger]="option.id === classroomCardActionsEnum.break_contract"
             (click)="onAction(option)">{{ option.label | customLocale }}</div>
      </ng-container>
    </on-ui-card-menu>
  </div>
</ng-template>

<ng-template #footer>
  <div class="footer">
    <ng-container *ngTemplateOutlet="classroom?.can?.schedule_meeting ? participants : tutor"></ng-container>
    <div class="action">
      <on-ui-button class="transparent"
                    [routerLink]="classroomUrl"
                    [label]="'classrooms.classroom.open-classroom' | customLocale">
      </on-ui-button>
    </div>
  </div>
</ng-template>

<!-- Modals -->

<ng-template [ngIf]="meetingModal">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileMeetingForm" [canClose]="false" (closed)="closeMeetingModal()">
    <app-modal-body>
      <app-classroom-meeting-form-wrapper
        [classroom]="classroom"
        (saved)="closeMeetingModal()"
      ></app-classroom-meeting-form-wrapper>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileMeetingForm>
    <app-mobile-modal (closed)="closeMeetingModal()">
      <app-mobile-modal-title>{{ 'lingo2-forms.meetings.form-title' | customLocale }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-classroom-meeting-form-wrapper
          [classroom]="classroom"
          (saved)="closeMeetingModal()"
        ></app-classroom-meeting-form-wrapper>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>


<ng-template [ngIf]="inviteModal">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileInviteForm"
             [canClose]="false"
             [middle]="true"
             (closed)="closeInviteModal()">
    <app-modal-body>
      <app-invite-to-classroom [classroom]="classroom"></app-invite-to-classroom>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileInviteForm>
    <app-mobile-modal (closed)="closeInviteModal()">
      <app-mobile-modal-title>{{ 'classrooms.invite.title' | customLocale }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-invite-to-classroom [classroom]="classroom"></app-invite-to-classroom>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>

<app-alert *ngIf="classBreakAlertShow && alertData" [type]="alertData.type">
  <ng-container alert-title>{{alertData.title | customLocale}}</ng-container>
  <ng-container alert-body>{{alertData.description | customLocale}}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="{{alertData.closeBtnText}}"
                  class="primary outline"
                  (onclick)="classBreakAlertShow = false">
    </on-ui-button>
    <on-ui-button label="{{alertData.confirmBtnText}}"
                  class="primary"
                  (onclick)="breakUserServiceContract()">
    </on-ui-button>
  </ng-container>
</app-alert>
